import { render, staticRenderFns } from "./AllNotificationComponent.vue?vue&type=template&id=11decef6&scoped=true&"
import script from "./AllNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./AllNotificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11decef6",
  null
  
)

export default component.exports